import { create } from "apisauce";
import ErrorHandler from "./errorHandler";
import FormData from "form-data";
/**
 * init class API
 * @param opt
 * @returns {hwkAPI}
 * @constructor
 */

class hwkAPI {
  constructor(opt) {
    opt = opt || {};
    this.classVersion = "1.0.0";
    this.apiUrl = opt.apiUrl;
    this.webUrl = opt.webUrl;
    this.staticURL = opt.staticUrl;
    this.token = opt.token;
    this.debug = opt.debug || false;

    this.api = create({
      baseURL: opt.apiUrl,
      headers: {
        Accept: opt.accept || "application/json"
      }
    });

    //  Error Handler
    this.errorHandler = new ErrorHandler({});

    // Bindings
    this.injectApiToken = this.injectApiToken.bind(this);
  }

  injectApiToken() {
    // Implement functionallity
  }

  getRegions = (params = {}) => {
    console.log("Calling getRegions in hwkAPI");
    return this.api.get("/regions", params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  createRegion = (params = {}) => {
    console.log("Calling createRegion in hwkAPI");
    return this.api.post(`/regions`, params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  updateRegion = (params = {}) => {
    console.log("Calling updateRegion in hwkAPI");
    return this.api.post(`/regions/${params.id}`, params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  deleteRegion = (id = null) => {
    console.log("Calling deleteRegion in hwkAPI and params", id);

    return this.api.delete(`/regions/${id}`).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  getProducts = (params = {}) => {
    console.log("Calling getProducts in hwkAPI");
    return this.api.get("/products/all", params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  createProduct = (params = {}) => {
    console.log("Calling createProduct in hwkAPI");
    return this.api.post(`/products/create`, params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  updateProduct = (params = {}) => {
    console.log("Calling updateProduct in hwkAPI");
    return this.api.post(`/products/${params.id}`, params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  updateProductPhoto = (params = {}) => {
    console.log("Calling updateProductPhoto in hwkAPI");

    const config = {
      headers: { "Content-Type": "multipart/form-data" }
    };

    if (params.image) {
      const formData = new FormData();
      formData.append("id", params.id);
      formData.append("image", params.image);

      return this.api
        .post("/products/photo", formData, config)
        .then(response => {
          this.debugLog("Original Response:", response);

          if (response.ok === false) {
            this.errorHandler.handle(response);
          }

          return response.data;
        });
    }

    throw new Error("Invalid image. Please select another one!");
  };

  deleteProduct = (id = null) => {
    console.log("Calling deleteProduct in hwkAPI and params", id);

    return this.api.delete(`/products/${id}`).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  getProductVideos = (params = {}) => {
    console.log("Calling getProductVideos in hwkAPI");
    return this.api.get("/products/videos", params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  createProductVideo = (params = {}) => {
    console.log("Calling createProductVideo in hwkAPI");
    return this.api
      .post(`/products/${params.productId}/videos`, params)
      .then(response => {
        this.debugLog("Original Response:", response);

        if (response.ok === false) {
          this.errorHandler.handle(response);
        }

        return response.data;
      });
  };

  deleteProductVideo = (productId = null, videoId = null) => {
    console.log(
      "Calling deleteProductVideo in hwkAPI and params",
      productId,
      videoId
    );

    return this.api
      .delete(`/products/${productId}/videos/${videoId}`)
      .then(response => {
        this.debugLog("Original Response:", response);

        if (response.ok === false) {
          this.errorHandler.handle(response);
        }

        return response.data;
      });
  };

  getSportTypes = (params = {}) => {
    console.log("Calling getSportTypes in hwkAPI");
    return this.api.get("/sport-types", params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  updateSportType = (params = {}) => {
    console.log("Calling updateSportType in hwkAPI");
    return this.api
      .post(`/sport-types/${params.id}`, params.form)
      .then(response => {
        this.debugLog("Original Response:", response);

        if (response.ok === false) {
          this.errorHandler.handle(response);
        }

        return response.data;
      });
  };

  createSportType = (params = {}) => {
    console.log("Calling createSportType in hwkAPI");
    return this.api.post(`/sport-types`, params.form).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  deleteSportType = (id = null) => {
    console.log("Calling deleteSportType in hwkAPI and params", id);

    return this.api.delete(`/sport-types/${id}`).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  updateSportVariant = (params = {}) => {
    console.log("Calling updateSportVariant in hwkAPI");
    return this.api
      .post(`/sport-variants/${params.id}`, params.form)
      .then(response => {
        this.debugLog("Original Response:", response);

        if (response.ok === false) {
          this.errorHandler.handle(response);
        }

        return response.data;
      });
  };

  createSportVariant = (params = {}) => {
    console.log("Calling createSportVariant in hwkAPI and params", params);
    return this.api
      .post(`/sport-variants`, {
        name: params.form.name,
        sport_type_id: params.sport_type_id
      })
      .then(response => {
        this.debugLog("Original Response:", response);

        if (response.ok === false) {
          this.errorHandler.handle(response);
        }

        return response.data;
      });
  };

  deleteSportVariant = (id = null) => {
    console.log("Calling deleteSportVariant in hwkAPI and params", id);

    return this.api.delete(`/sport-variants/${id}`).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  getSportVariants = (params = {}) => {
    console.log("Calling getSportVariants in hwkAPI");
    return this.api.get("/sport-variants", params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  getConditions = (params = {}) => {
    console.log("Calling getConditions in hwkAPI");
    return this.api.get("/conditions", params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  createCondition = (params = {}) => {
    console.log("Calling createCondition in hwkAPI and params", params);

    const conditionEndpoint =
      params.type === "sportType"
        ? `/conditions/sport-types/${params.id}`
        : `/conditions/sport-variants/${params.id}`;

    return this.api.post(conditionEndpoint, params.form).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  updateCondition = (params = {}) => {
    console.log("Calling updateCondition in hwkAPI and params", params);

    return this.api
      .post(`/conditions/${params.id}/update`, params)
      .then(response => {
        this.debugLog("Original Response:", response);

        if (response.ok === false) {
          this.errorHandler.handle(response);
        }

        return response.data;
      });
  };

  deleteCondition = (id = null) => {
    console.log("Calling deleteCondition in hwkAPI and params", id);

    return this.api.delete(`/conditions/${id}`).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  requestWishlistEmail = params => {
    console.log("Calling requestWishlistEmail in hwkAPI and params", params);
    return this.api.post(`/wishlist/request-email`, params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  doUpdatePushNotifications = (token, device, status) => {
    const params = { token, device, status };
    console.log(
      "Calling doUpdatePushNotifications in hwkAPI and params",
      params
    );
    return this.api
      .post(`/push-notifications/tokens/update`, params)
      .then(response => {
        this.debugLog("Original Response:", response);

        if (response.ok === false) {
          this.errorHandler.handle(response);
        }

        return response.data;
      });
  };

  getPushNotificationsStatus = token => {
    console.log(
      "Calling getPushNotificationsStatus in hwkAPI for token:",
      token
    );
    return this.api
      .post("/push-notifications/tokens/status", { token })
      .then(response => {
        this.debugLog("Original Response:", response);

        if (response.ok === false) {
          this.errorHandler.handle(response);
        }

        return response.data.data;
      });
  };

  getWeatherProviders = (params = {}) => {
    console.log("Calling getWeatherProviders in hwkAPI");
    return this.api.get("/weather-providers", params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  createWeatherProvider = (params = {}) => {
    console.log("Calling createWeatherProvider in hwkAPI");
    return this.api.post(`/weather-providers`, params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  updateWeatherProvider = (params = {}) => {
    console.log("Calling updateWeatherProvider in hwkAPI");
    return this.api.post(`/weather-providers/${params.id}`, params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  deleteWeatherProvider = (id = null) => {
    console.log("Calling deleteWeatherProvider in hwkAPI and params", id);

    return this.api.delete(`/weather-providers/${id}`).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };


  getPushNotifications = (params = {}) => {
    console.log("Calling getPushNotifications in hwkAPI");
    return this.api.get("/push-notifications", params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  createPushNotification = (params = {}) => {
    console.log("Calling createPushNotification in hwkAPI");
    return this.api.post(`/push-notifications`, params).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };

  deletePushNotification = (id = null) => {
    console.log("Calling deletePushNotification in hwkAPI and params", id);

    return this.api.delete(`/push-notifications/${id}`).then(response => {
      this.debugLog("Original Response:", response);

      if (response.ok === false) {
        this.errorHandler.handle(response);
      }

      return response.data;
    });
  };


  // Helpers
  // --------------

  debugLog = (...args) => {
    if (this.debug) {
      let copy = [].slice.call(args);
      console.log("[API DEBUG]: ", copy);
    }
  };

  randomString = (
    length = 32,
    chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
  ) => {
    let result = "";
    for (let i = length; i > 0; --i) {
      result += chars[Math.round(Math.random() * (chars.length - 1))];
    }
    return result;
  };
}

export default hwkAPI;
